import { createSelector } from 'reselect';

const selectHomeDomain = state => state.get('home');

export const selectSendingStatus = createSelector(
  selectHomeDomain,
  state => state.getIn(['buyForm', 'isSending']),
);

export const selectSuccessStatus = createSelector(
  selectHomeDomain,
  state => state.getIn(['buyForm', 'isSuccess']),
);

export const selectFailureStatus = createSelector(
  selectHomeDomain,
  state => state.getIn(['buyForm', 'isFailure']),
);


// WEBPACK FOOTER //
// ./src/modules/home/home.selector.js